import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Kontakt.module.css';
import enTexts from './KontaktEn.json';
import deTexts from './KontaktDe.json';
import { FaGithub, FaLinkedin, FaEnvelope } from 'react-icons/fa';

function Kontakt() {
    const { i18n } = useTranslation();
    const currentLang = i18n.language;
    const texts = currentLang.startsWith('de') ? deTexts : enTexts;

    return (
        <div className={styles.container}>
            {/* Header mit Hintergrundbild */}
            <div className={styles.header}></div>

            {/* Link-Bereich */}
            <div className={styles.linksContainer}>
                <div className={styles.linkItem}>
                    <p className={styles.linkCaption}>{texts.githubCaption}</p>
                    <div className={styles.linkWithIcon}>
                        <FaGithub className={styles.icon} />
                        <a
                            href="https://github.com/d0ener4ever/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {texts.githubLink}
                        </a>
                    </div>
                </div>
                <div className={styles.linkItem}>
                    <p className={styles.linkCaption}>{texts.linkedinCaption}</p>
                    <div className={styles.linkWithIcon}>
                        <FaLinkedin className={styles.icon} />
                        <a
                            href="https://www.linkedin.com/in/lukas-bochnick/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {texts.linkedinLink}
                        </a>
                    </div>
                </div>
                <div className={styles.linkItem}>
                    <p className={styles.linkCaption}>{texts.emailCaption}</p>
                    <div className={styles.linkWithIcon}>
                        <FaEnvelope className={styles.icon} />
                        <a
                            href="mailto:lukas@bochnick.de?subject=Kontaktaufnahme&body=Hallo,%20ich%20möchte%20mit%20dir%20Kontakt%20aufnehmen."
                        >
                            {texts.emailLink}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Kontakt;
